import React from 'react';
import { useAd } from '../../context/AdContext';
import GoogleAd from '../AdProviders/GoogleAd';
import styles from './AdOverlay.module.css';

const AdOverlay = () => {
  const { 
    showAd, 
    handleAdLoaded, 
    handleAdCompleted,
    handleAdError 
  } = useAd();
  
  if (!showAd) return null;
  
  console.log('Rendering AdOverlay content, showAd =', showAd);
  
  return (
    <div className={styles.adOverlay}>
      <div className={styles.adContainer}>
        <div className={styles.adHeader}>
          <h2>Watch an ad to earn tokens</h2>
          <p>You'll be able to play after watching this short ad</p>
        </div>
        
        <GoogleAd
          onAdLoaded={handleAdLoaded}
          onAdCompleted={handleAdCompleted}
          onAdError={handleAdError}
        />
      </div>
    </div>
  );
};

export default AdOverlay;
